import React from "react";

const EmailPage = () => {
  return (
    <div
      style={{
        padding: "24px",
        background: "#fff",
        minHeight: "100%",
        borderRadius: "8px",
      }}
    >
      <h1>Email Page</h1>
    </div>
  );
};

export default EmailPage;
